export default __webpack_public_path__ + "static/media/times-new-roman-grassetto.1bc432f7.ttf";